import { createContext, ReactNode, useContext } from 'react';

const FooterSectionsContext = createContext(false);

export const useIsFooterSection = (): boolean => useContext(FooterSectionsContext);

type FooterSectionsProviderProps = {
  children: ReactNode;
};

export function FooterSectionsProvider({ children }: Readonly<FooterSectionsProviderProps>) {
  return <FooterSectionsContext.Provider value>{children}</FooterSectionsContext.Provider>;
}
